export const cmsConstants = {
  EDIT_MODE_ON: "EDIT_MODE_ON",
  EDIT_MODE_OFF: "EDIT_MODE_OFF",
  SET_ENVIROMENT: "SET_ENVIROMENT",
  SET_ENVIROMENT_LANG: "SET_ENVIROMENT_LANG",
  CONTAINER_UPDATED: "CONTAINER_UPDATED",
  CONTAINER_TO_UPDATE: "CONTAINER_TO_UPDATE",
  CONTAINER_ADDED: "CONTAINER_ADDED",
  SET_SOURCE_LOCATION: "SET_SOURCE_LOCATION",
  LOAD_CLIENT_FONTS: "LOAD_CLIENT_FONTS",
  REMOVE_CLIENT_FONT: "REMOVE_CLIENT_FONT",
  ADD_CLIENT_FONT: "ADD_CLIENT_FONT",

  ALERT_NEW_MODIFICATIONS: "ALERT_NEW_MODIFICATIONS",
  GLOBAL_SAVING_LOADER: "IS_LOADING",
  TOGGLE_INHERITAGE_INFO: 'TOGGLE_INHERITAGE_INFO',
  INHERITAGE_AFFECTED: 'INHERITAGE_AFFECTED',
  GLOBAL_SAVING_LOADER: "IS_LOADING",
  BLOCK_DESELECT: 'BLOCK_DESELECT'
};
